
import React from "react";
import AdminLayout from "@/components/AdminLayout";
import WidgetStatusTable from "@/components/admin/WidgetStatusTable";

/**
 * This page shows the live status of all widget installations for admins.
 * Add route: /admin/widget-status 
 */
const AdminWidgetStatusPage: React.FC = () => {
  return (
    <AdminLayout title="Widget Status">
      <WidgetStatusTable />
    </AdminLayout>
  );
};

export default AdminWidgetStatusPage;
